import { BaseFilterInput } from "./types";

export const generateFilterId = (): string => {
  const randomPart = crypto.randomUUID().replace(/-/g, "").substring(0, 8);
  return `flt_c_${randomPart}`;
};

const normalizeFilter = <T extends BaseFilterInput>(filter: T): Record<string, unknown> => {
  const { id: _omittedId, ...rest } = filter as { id?: string } & Record<string, unknown>;
  const keys = Object.keys(rest).sort();

  return keys.reduce<Record<string, unknown>>((acc, key) => {
    const value = (rest as Record<string, unknown>)[key];
    acc[key] = key === "values" && Array.isArray(value) ? [...value].sort() : value;
    return acc;
  }, {});
};

export const areFiltersSemanticallyEqual = <T extends BaseFilterInput>(
  initialFilters: T[] = [],
  currentFilters: T[] = []
): boolean => {
  if (initialFilters === currentFilters) {
    return true;
  }
  if (initialFilters.length !== currentFilters.length) {
    return false;
  }

  const counts = new Map<string, number>();
  for (const filter of initialFilters) {
    const key = JSON.stringify(normalizeFilter(filter));
    counts.set(key, (counts.get(key) ?? 0) + 1);
  }

  for (const filter of currentFilters) {
    const key = JSON.stringify(normalizeFilter(filter));
    const current = counts.get(key);
    if (!current) {
      return false;
    }
    if (current === 1) {
      counts.delete(key);
    } else {
      counts.set(key, current - 1);
    }
  }

  return counts.size === 0;
};
